import React from 'react';
import { profile } from '../data/portfolio';
import Icon from './Icon';
import './ProjectCredit.css';

export default function ProjectCredit({ collaboration }) {
  const { creator, role, article } = collaboration;
  return (
    <section className="project-credit" aria-labelledby="project-credit-title">
      <div className="project-credit-copy">
        <span className="eyebrow">Good work deserves its credit</span>
        <h2 id="project-credit-title">Built by<br /><em>{creator}.</em></h2>
        <p>Shout-out to {creator} for leading and building the PIM ingestion rebuild. I collaborated on this project at Tyroo, and the credit for the rebuild belongs to him.</p>
        <dl className="project-credit-roles">
          <div><dt>Project lead &amp; creator</dt><dd>{creator}</dd></div>
          <div><dt>My role</dt><dd>{role}<span>{profile.name}</span></dd></div>
        </dl>
      </div>
      <article className="project-source-article">
        <div className="project-source-top"><span className="eyebrow">In his own words</span><span>{article.platform}</span></div>
        <h3>{article.title}</h3>
        <p className="project-source-byline">Written by {creator}</p>
        <p>The story of the rebuild, told by the engineer who built it.</p>
        <a className="text-link" href={article.url} target="_blank" rel="noopener noreferrer" aria-label={`Read ${creator}’s article on ${article.platform} (opens in a new tab)`}>Read Siddharth’s article <Icon kind="diagonal" /></a>
      </article>
    </section>
  );
}
